(function () {
  var root = document.getElementById('MainProduct');
  if (!root) return;

  var mainImg = document.getElementById('ProductMainImage');
  root.querySelectorAll('.product-gallery__thumb').forEach(function (btn) {
    btn.addEventListener('click', function () {
      root.querySelectorAll('.product-gallery__thumb').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      if (mainImg) mainImg.src = btn.getAttribute('data-full');
    });
  });

  var tabButtons = root.parentElement.querySelectorAll('.product-tabs__nav button');
  tabButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = btn.getAttribute('data-tab');
      tabButtons.forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      document.querySelectorAll('.product-tabs__panel').forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-panel') === target);
      });
    });
  });

  var quantityInput = root.querySelector('input[name="quantity"]');
  var productForm = root.querySelector('form');
  var getStockState = function (variant) {
    var tracked = !!(variant && variant.inventory_management);
    var quantity = tracked ? Math.max(0, Number(variant.inventory_quantity) || 0) : 0;
    return { tracked: tracked, quantity: quantity, available: !!(variant && variant.available && (!tracked || quantity > 0)) };
  };
  var applyQuantityLimit = function (variant) {
    if (!quantityInput || !variant) return;
    var stock = getStockState(variant);
    if (stock.tracked) {
      quantityInput.max = String(stock.quantity);
      if (stock.quantity > 0) {
        var value = Math.max(1, parseInt(quantityInput.value, 10) || 1);
        quantityInput.value = String(Math.min(stock.quantity, value));
      }
    } else {
      quantityInput.removeAttribute('max');
    }
  };
  var setAddButtonState = function (variant) {
    var stock = getStockState(variant);
    applyQuantityLimit(variant);
    var addBtn = document.getElementById('AddToCartButton');
    if (addBtn) {
      addBtn.disabled = !stock.available;
      addBtn.textContent = stock.available
        ? (addBtn.getAttribute('data-add-label') || 'Add to Cart')
        : (addBtn.getAttribute('data-sold-out-label') || 'Out Of Stock');
    }
  };
  if (productForm && quantityInput) {
    productForm.addEventListener('submit', function (event) {
      var max = parseInt(quantityInput.getAttribute('max'), 10);
      var value = parseInt(quantityInput.value, 10) || 1;
      if (!isNaN(max) && max > 0 && value > max) quantityInput.value = String(max);
      if (!isNaN(max) && max <= 0) {
        event.preventDefault();
        quantityInput.value = '1';
      }
    });
  }

  var optionSelects = root.querySelectorAll('.product-option-select');
  if (optionSelects.length && window.__productVariants) {
    var updateVariant = function () {
      var selected = Array.from(optionSelects).map(function (s) { return s.value; });
      var match = window.__productVariants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      });
      if (!match) return;
      var idInput = document.getElementById('ProductVariantId');
      if (idInput) idInput.value = match.id;
      var priceEl = document.getElementById('ProductPrice');
      if (priceEl) {
        var html = '';
        if (match.compare_at_price_money && match.compare_at_price_cents > match.price_cents) {
          html += '<s>' + match.compare_at_price_money + '</s>';
        }
        html += match.price_money;
        priceEl.innerHTML = html;
      }
      setAddButtonState(match);
      if (match.featured_image) mainImg.src = match.featured_image;
    };
    optionSelects.forEach(function (s) { s.addEventListener('change', updateVariant); });
  }

  if (window.__productVariants && window.__productVariants.length) {
    var initialId = document.getElementById('ProductVariantId');
    var initialVariant = window.__productVariants.find(function (variant) {
      return initialId && String(variant.id) === String(initialId.value);
    }) || window.__productVariants[0];
    setAddButtonState(initialVariant);
  }

  var buyRow = root.querySelector('.product-info__buy-row');
  var stickyBar = document.getElementById('ProductStickyBar');
  if (buyRow && stickyBar && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBar.style.display = entry.isIntersecting ? 'none' : 'flex';
      });
    });
    observer.observe(buyRow);
  }
})();

